import { useMemo } from "react"
import { IntlShape } from "react-intl"
import { EZoomType } from "../../enums/animationSettings"
import { message } from "../../messages/animationSettings"

export default function useZoomTypeSelection(intl: IntlShape) {
    return useMemo(
        () => [
            {
                label: intl.formatMessage(message.magnifier),
                value: EZoomType.Magnifier,
            },
            {
                label: intl.formatMessage(message.enlarger),
                value: EZoomType.Enlarger,
            },
            {
                label: intl.formatMessage(message.zoom),
                value: EZoomType.Zoom,
            },
            {
                label: intl.formatMessage(message.none),
                value: EZoomType.None,
            },
        ],
        [intl],
    )
}
